import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { addInfraction, getUserInfractions, AddInfractionParams } from '@/services/infractionService';
import { toast } from 'sonner';

export const useInfractions = (userId?: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { data: infractions, isLoading } = useQuery({
    queryKey: ['user-infractions', userId],
    queryFn: () => getUserInfractions(userId!),
    enabled: !!userId,
  });

  const addInfractionMutation = useMutation({
    mutationFn: (params: AddInfractionParams) => addInfraction(params),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['user-infractions'] });
      queryClient.invalidateQueries({ queryKey: ['admin-users'] });

      const strikeMsg = data.strike_count === 4
        ? t('adminPanel.toasts.permanentBan')
        : t('adminPanel.toasts.strikeApplied', { count: data.strike_count });

      toast.success(`${t('adminPanel.toasts.infractionRegistered')}. ${strikeMsg}`);
    },
    onError: (error: any) => {
      toast.error(error.message || t('adminPanel.toasts.errorInfraction'));
    },
  });

  return {
    infractions: infractions || [],
    isLoading,
    addInfraction: addInfractionMutation.mutate,
    isAdding: addInfractionMutation.isPending,
  };
};
